let ctx = null;

export function unlockAudio() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume();
  } catch (e) {
    console.warn("audio unlock failed", e);
  }
}

// Cartoon rocket whoosh: swept noise + rising "pew" tone, synthesized (no asset).
export function playRocket() {
  if (!ctx) unlockAudio();
  if (!ctx) return;
  const t0 = ctx.currentTime;
  const dur = 1.6;
  const master = ctx.createGain();
  master.gain.setValueAtTime(0.0001, t0);
  master.gain.exponentialRampToValueAtTime(0.8, t0 + 0.15);
  master.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  master.connect(ctx.destination);

  const buffer = ctx.createBuffer(1, ctx.sampleRate * dur, ctx.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
  const noise = ctx.createBufferSource();
  noise.buffer = buffer;
  const band = ctx.createBiquadFilter();
  band.type = "bandpass";
  band.Q.value = 0.9;
  band.frequency.setValueAtTime(180, t0);
  band.frequency.exponentialRampToValueAtTime(2600, t0 + dur * 0.8);
  noise.connect(band).connect(master);
  noise.start(t0);

  const osc = ctx.createOscillator();
  osc.type = "triangle";
  osc.frequency.setValueAtTime(220, t0);
  osc.frequency.exponentialRampToValueAtTime(1400, t0 + 0.9);
  osc.frequency.exponentialRampToValueAtTime(900, t0 + dur);
  const og = ctx.createGain();
  og.gain.setValueAtTime(0.0001, t0);
  og.gain.exponentialRampToValueAtTime(0.25, t0 + 0.2);
  og.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(og).connect(master);
  osc.start(t0);
  osc.stop(t0 + dur);
}
